import Product from './Product';
import {get, writable} from 'svelte/store';

const data = {timeout: false, interval: false, active: false, start: 0, progress: 0, duration: 1500};
const next = writable(data);

next.setCancel = () => {
	if (data.timeout)
		clearTimeout(data.timeout);

	if (data.interval)
		clearInterval(data.interval);

	data.timeout = false;
	data.interval = false;
	data.active = false;
	data.start = 0;
	data.progress = 0;
	next.set(data);
};

next.setNext = wait => {
	next.setCancel();
	if (!wait) {
		const proceed = () => {
			next.setCancel();
			Product.setNext();
		};

		const progress = () => {
			const elapsed = Date.now() - data.start;
			data.progress = parseInt((elapsed * 100) / data.duration);
			next.set(data);
		};

		const valid = get(Product).property.selected.valid;
		if (valid) {
			data.timeout = setTimeout(proceed, data.duration);
			data.interval = setInterval(progress, 100);
			data.active = true;
			data.start = Date.now();
			next.set(data);
		}
	}
};

export default next;